<template>
  <div class="row" style="margin-top: 15px">
    <fieldset>
      <legend style="width: 410px">Quantidade de atendimento por unidade</legend>
      <div class="row">
        <div class="title-group">Período</div>
        <div class="group-itens">
          <div class="item-filter">
            <a-date-picker show-time type="date" placeholder="Data Início" style="width: 100%" format="DD/MM/yyyy" v-model:value="form.dataInicio" />
          </div>
          <div class="item-filter">
            <a-date-picker show-time type="date" placeholder="Data Fim" style="width: 100%" format="DD/MM/yyyy" v-model:value="form.dataFim" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="title-group">Unidade</div>
        <div class="group-itens">
          <Multiselect v-model="form.objetoConsulta" display="chip" placeholder="Selecione as unidades" :maxSelectedLabels="3" class="w-10rem" :options="unidadeAtendimento" optionValue="descricao" optionLabel="descricao"></Multiselect>
        </div>
      </div>
      <div class="row" style="margin-top: 15px">
        <div style="width: 180px">
          <a-tooltip title="Pesquisar" placement="top">
            <div class="input-group-prepend icon" style="text-align: center">
              <span class="input-group-text bg-white" @click="searchUnidadeAtendimento">
                <i class="fa fa-search" style="margin: 0px 10px"></i>
                <span>Pesquisar</span>
              </span>
            </div>
          </a-tooltip>
        </div>
        <div class="col"></div>
        <div style="display: flex; flex-direction: row; width: 380px">
          <div style="width: 150px">
            <a-tooltip title="Imprimir" placement="top" v-if="dataUnidadeAtendimento.length > 0" @click="imprimirPDF">
              <div class="input-group-prepend icon" style="text-align: center">
                <span class="input-group-text bg-white">
                  <i class="fa-solid fa-print" style="margin: 0px 10px"></i>
                  <span>Imprimir</span>
                </span>
              </div>
            </a-tooltip>
          </div>
          <div style="width: 170px">
            <a-tooltip title="Imprimir" placement="top" v-if="dataUnidadeAtendimento.length > 0" @click="encaminharEmail">
              <div class="input-group-prepend icon" style="text-align: center">
                <span class="input-group-text bg-white">
                  <i class="fa-solid fa-share" style="margin: 0px 10px"></i>
                  <span>Encaminhar</span>
                </span>
              </div>
            </a-tooltip>
          </div>
        </div>
      </div>
      <div class="row" style="margin-top: 10px">
        <a-table :dataSource="dataUnidadeAtendimento" :columns="columns"> </a-table>
      </div>
      <div id="iframe"></div>
    </fieldset>
  </div>
</template>

<script>
import { gerarRelatorioHtml, gerarRelatorioPdf } from '@/components/service/gerarRelatorio';
import { getUnidadeAtendimentoRelatorio } from '@/components/service/registroAtendimentoService';
import { getUnidadeAtendimento } from '@/config/servicos-utils';
import { abrirImpressaoPorBlob, encaminharEmailTo, formatarData } from '@/utils/servicos-utils';

export default {
  name: 'AtendimentoUnidadeRelatorio',
  data() {
    return {
      dataInicio: null,
      dataFim: null,
      unidadeAtendimento: [],
      selectOptions: [],
      form: {
        todos: false,
        objetoConsulta: [],
        dataInicio: null,
        dataFim: null,
      },
      dataUnidadeAtendimento: [],
      columns: [
        {
          title: 'Unidade de Atendimento',
          dataIndex: 'descricao',
          key: 'descricao',
        },
        {
          title: 'Quantidade',
          dataIndex: 'quantidade',
          key: 'quantidade',
        },
      ],
    };
  },
  async created() {
    await this.getUnidadeAtendimento();
  },
  methods: {
    async searchUnidadeAtendimento() {
      let dataInicio = this.form.dataInicio;
      let dataFim = this.form.dataFim;
      if (this.form.dataInicio != null) {
        this.form.dataInicio = formatarData(new Date(this.form.dataInicio), 'DD/MM/YYYY');
        if (this.form.dataFim != null) {
          this.form.dataFim = formatarData(new Date(this.form.dataFim), 'DD/MM/YYYY');
        }
      }
      await getUnidadeAtendimentoRelatorio(this.form).then((r) => {
        this.form.dataInicio = dataInicio;
        this.form.dataFim = dataFim;
        this.dataUnidadeAtendimento = r.data;
      });
    },
    async imprimirPDF() {
      if (this.dataUnidadeAtendimento.length > 0) {
        await gerarRelatorioPdf({
          listaDadosDocumento: this.dataUnidadeAtendimento,
          nomeDocumentoHtml: 'relatorio-unidade-atendimento.html',
        }).then((r) => {
          abrirImpressaoPorBlob(r.data);
        });
      }
    },
    async encaminharEmail() {
      if (this.dataUnidadeAtendimento.length > 0) {
        await gerarRelatorioHtml({
          listaDadosDocumento: this.dataUnidadeAtendimento,
          nomeDocumentoHtml: 'relatorio-unidade-atendimento.html',
        }).then((r) => {
          encaminharEmailTo('Relatório de Quantidade de Atendimento por Unidade', r.data);
        });
      }
    },
    async getUnidadeAtendimento() {
      await getUnidadeAtendimento().then((r) => (this.unidadeAtendimento = r.data));
    },
  },
};
</script>

<style scoped>
.title-group {
  margin-bottom: 5px;
  font-size: 16px;
  font-weight: bold;
}

.group-itens {
  display: flex;
  flex-direction: row;
}

.form-check-label {
  font-size: 14px;
  margin: 0px 10px;
}

.input-group-prepend {
  cursor: pointer;
}

.input-group-text {
  padding: 0.375rem 26px 4px 11px;
  height: 38px;
}

.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  background: #2bec96 !important;
}

.icon {
  cursor: pointer;
}

.item-filter {
  margin: 10px;
}

.item-filter.form-check-input {
  margin: 10px;
}
</style>
